import type { Analysis } from '@/types';

export const analyses: Analysis[] = [
  {
    id: 'an001',
    title: '足球黑5指数月度全景：进攻效率整体走高',
    subtitle: '五大联赛近 30 天黑5数据横向对比与趋势解读',
    categoryId: 'football',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20rising%20bar%20charts%20and%20grid%20lines%20in%20deep%20navy%20and%20orange%2C%20minimal%20analytical%20theme%2C%20dark%20background%2C%20no%20text&width=1200&height=675&seq=an-football-01&orientation=landscape',
    updatedAt: '2026-10-15',
    readTime: '8 分钟',
    author: '赛事数据组',
    intro:
      '本月五大联赛黑5综合指数整体抬升 2.4 个点，进攻效率的改善是最主要驱动力。本专题从联赛、球队、场次三个维度拆解数据变化，帮助读者理解整体走势。',
    groups: [
      {
        name: '五大联赛整体对比',
        desc: '按联赛维度统计黑5综合指数与进攻效率均值',
        rows: [
          { label: '英格兰超级联赛', value: '88.4', change: '+3.1' },
          { label: '西班牙甲级联赛', value: '86.9', change: '+2.2' },
          { label: '意大利甲级联赛', value: '84.2', change: '+1.4' },
          { label: '德国甲级联赛', value: '85.7', change: '+2.8' },
          { label: '法国甲级联赛', value: '82.6', change: '-0.5' },
        ],
      },
      {
        name: '进攻效率 TOP 5 球队',
        desc: '近 30 天进攻效率指数排名',
        rows: [
          { label: '曼城', value: '92.1', change: '+4.6' },
          { label: '巴塞罗那', value: '90.5', change: '+3.9' },
          { label: '拜仁慕尼黑', value: '89.8', change: '+3.2' },
          { label: '利物浦', value: '88.3', change: '+2.7' },
          { label: '国际米兰', value: '86.4', change: '+1.1' },
        ],
      },
      {
        name: '关键场次走势',
        desc: '焦点战黑5指数分时段表现',
        rows: [
          { label: '上半场 0-30 分钟', value: '84.6', change: '+1.8' },
          { label: '上半场 30-45 分钟', value: '86.2', change: '+2.4' },
          { label: '下半场 45-75 分钟', value: '88.9', change: '+3.6' },
          { label: '下半场 75-90 分钟', value: '85.1', change: '+0.9' },
          { label: '补时阶段', value: '79.4', change: '-1.2' },
        ],
      },
    ],
    conclusion:
      '整体来看，五大联赛的进攻节奏在加快，下半场 45-75 分钟是黑5指数的峰值时段。法国联赛是唯一出现回落的联赛，主要受多支球队防守收缩策略影响。后续可重点跟踪进攻效率 TOP 5 球队的对位场次。',
    relatedIds: ['an002', 'an004'],
  },
  {
    id: 'an002',
    title: '篮球黑5专项：三分命中率与黑5指数的相关性',
    subtitle: 'NBA 与 CBA 三分数据对比赛果的量化拆解',
    categoryId: 'basketball',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20analytical%20dashboard%20with%20scatter%20plots%20and%20statistics%20panels%20in%20teal%20and%20orange%20on%20dark%20background%2C%20minimal%20data%20theme%2C%20no%20text&width=1200&height=675&seq=an-basketball-01&orientation=landscape',
    updatedAt: '2026-10-14',
    readTime: '6 分钟',
    author: '赛事数据组',
    intro:
      '三分球在现代篮球中的权重持续上升。本专题通过近 60 场比赛数据，量化三分命中率与黑5综合指数之间的关系，并给出可参考的观察指标。',
    groups: [
      {
        name: '三分命中率区间对比',
        desc: '按命中率区间统计平均黑5指数',
        rows: [
          { label: '45% 以上', value: '91.2', change: '+5.4' },
          { label: '40% - 45%', value: '87.6', change: '+3.1' },
          { label: '35% - 40%', value: '83.4', change: '+0.6' },
          { label: '30% - 35%', value: '78.9', change: '-2.2' },
          { label: '30% 以下', value: '74.3', change: '-4.8' },
        ],
      },
      {
        name: '篮板与助攻贡献',
        desc: '辅助指标对黑5指数的影响',
        rows: [
          { label: '篮板领先方胜率', value: '64%', change: '+6.2' },
          { label: '助攻领先方胜率', value: '71%', change: '+8.4' },
          { label: '失误更少方胜率', value: '68%', change: '+5.1' },
          { label: '替补得分领先方胜率', value: '59%', change: '+2.7' },
          { label: '罚球命中率领先方胜率', value: '57%', change: '+1.9' },
        ],
      },
      {
        name: '联赛差异化表现',
        desc: '两大联赛黑5指数结构对比',
        rows: [
          { label: 'NBA 平均回合数', value: '99.2', change: '+3.4' },
          { label: 'CBA 平均回合数', value: '91.6', change: '+1.2' },
          { label: 'NBA 三分出手占比', value: '41%', change: '+2.8' },
          { label: 'CBA 三分出手占比', value: '34%', change: '+1.5' },
          { label: 'NBA 黑5均值', value: '84.6', change: '+2.9' },
        ],
      },
    ],
    conclusion:
      '三分命中率与黑5指数呈明显正相关，命中率进入 40% 以上区间后指数上升速度加快。助攻领先方胜率最高，说明团队传导仍是决定比赛的关键。',
    relatedIds: ['an001', 'an003'],
  },
  {
    id: 'an003',
    title: '电竞黑5指数复盘：一血率与大龙控制的权重',
    subtitle: 'LPL 与 KPL 近 40 场对局的数据回归分析',
    categoryId: 'esports',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20esports%20data%20visualization%20with%20neon%20line%20charts%20and%20hexagon%20grid%20in%20teal%20and%20amber%20on%20dark%20background%2C%20no%20text&width=1200&height=675&seq=an-esports-01&orientation=landscape',
    updatedAt: '2026-10-13',
    readTime: '7 分钟',
    author: '赛事数据组',
    intro:
      '电竞比赛的节奏变化极快，前期资源争夺往往决定整局走势。本专题聚焦一血率、大龙控制与黑5指数的关系，给出阶段性的数据结论。',
    groups: [
      {
        name: '早期资源指标',
        desc: '前 15 分钟关键资源对胜率的影响',
        rows: [
          { label: '一血方获胜率', value: '62%', change: '+4.8' },
          { label: '一塔方获胜率', value: '69%', change: '+6.3' },
          { label: '首条小龙方获胜率', value: '58%', change: '+2.4' },
          { label: '前期经济领先 2k 以上获胜率', value: '81%', change: '+9.1' },
          { label: '阵容推塔优势方获胜率', value: '66%', change: '+3.7' },
        ],
      },
      {
        name: '中期资源指标',
        desc: '大龙与团战阶段的数据表现',
        rows: [
          { label: '拿下首条大龙获胜率', value: '79%', change: '+8.6' },
          { label: '团战 4 换 5 获胜率', value: '88%', change: '+11.2' },
          { label: '推掉两路高地获胜率', value: '84%', change: '+7.4' },
          { label: '场均大龙数', value: '1.6', change: '+0.2' },
          { label: '场均团战胜率差', value: '12.4%', change: '+1.8' },
        ],
      },
    ],
    conclusion:
      '前期经济领先 2k 以上的队伍胜率高达 81%，是黑5指数最强的先行指标。首条大龙的获取同样关键，拿下后胜率接近八成。建议在赛前重点评估队伍的前期节奏能力。',
    relatedIds: ['an002', 'an004'],
  },
  {
    id: 'an004',
    title: '往期黑5数据年度回顾：稳定与波动的边界',
    subtitle: '全年黑5指数分布、峰值时段与异常场次梳理',
    categoryId: 'football',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20annual%20data%20report%20visual%20with%20curved%20trend%20line%20and%20segmented%20bars%20in%20deep%20blue%20and%20orange%20on%20dark%20canvas%2C%20minimal%2C%20no%20text&width=1200&height=675&seq=an-general-01&orientation=landscape',
    updatedAt: '2026-10-10',
    readTime: '10 分钟',
    author: '赛事数据组',
    intro:
      '本专题对往期黑5数据进行年度回顾，梳理全年的指数分布特征、峰值时段以及明显偏离常态的异常场次，为后续分析提供基线参考。',
    groups: [
      {
        name: '全年指数分布',
        desc: '按区间统计场次占比',
        rows: [
          { label: '90 以上（极高）', value: '6.4%', change: '+0.8' },
          { label: '85 - 90（偏高）', value: '18.2%', change: '+1.4' },
          { label: '80 - 85（常态）', value: '42.6%', change: '-0.6' },
          { label: '75 - 80（偏低）', value: '24.1%', change: '-1.2' },
          { label: '75 以下（极低）', value: '8.7%', change: '-0.4' },
        ],
      },
      {
        name: '峰值时段统计',
        desc: '各时段的黑5指数均值',
        rows: [
          { label: '09:00 - 12:00', value: '78.2', change: '-1.4' },
          { label: '12:00 - 18:00', value: '80.6', change: '+0.4' },
          { label: '18:00 - 22:00', value: '86.4', change: '+2.8' },
          { label: '22:00 - 02:00', value: '84.1', change: '+1.2' },
          { label: '02:00 - 09:00', value: '77.6', change: '-0.8' },
        ],
      },
      {
        name: '异常场次梳理',
        desc: '偏离常态超过 10 个点的场次',
        rows: [
          { label: '指数骤升场次', value: '14 场', change: '+3' },
          { label: '指数骤降场次', value: '9 场', change: '-2' },
          { label: '持续高位场次', value: '21 场', change: '+5' },
          { label: '持续低位场次', value: '11 场', change: '-1' },
          { label: '波动幅度最大联赛', value: '英超', change: '+' },
        ],
      },
    ],
    conclusion:
      '全年黑5指数以 80-85 区间为常态，占比超过四成。晚间 18:00-22:00 是指数峰值时段，与赛事集中安排高度相关。英超是波动幅度最大的联赛，适合作为高关注度跟踪对象。',
    relatedIds: ['an001', 'an002'],
  },
];

export const findAnalysis = (id: string): Analysis | undefined =>
  analyses.find((item) => item.id === id);